<div class="page-body">
  <div *ngIf="internalServerError" class="error-wrapper">
    <div class="contents-container">
      <h3 class="general-error-text">Etwas ist schief gelaufen.</h3>
      <p class="info-text">
        Bitte versuchen Sie es erneut. Kontaktieren Sie uns, wenn das Problem
        weiterhin besteht.
      </p>
    </div>
  </div>

  <div *ngIf="loading && !internalServerError">
    <app-spinner></app-spinner>
  </div>

  <div
    *ngIf="!loading && currentView === View.DEFAULT && !internalServerError"
    class="contents-wrapper"
  >
    <div class="contents-container">
      <h1 class="heading">
        {{ state.currentPageInformation.pageSpecificParameters.heading }}
      </h1>
      <p class="info-text confirm-email-text">
        {{ state.currentPageInformation.pageSpecificParameters.subHeading }}
      </p>
      <form [formGroup]="form" id="email-and-phone-form">
        <div class="input-container">
          <zaver-animated-form-input
            [size]="'large'"
            [placeholder]="'E-Mail Adresse'"
            [formControlName]="'email'"
            [error]="form.controls.email.invalid && showError"
            [errorMessage]="'Bitte geben Sie eine gültige E-Mail Adresse ein'"
            [inputMode]="'email'"
            [autoComplete]="'email'"
            [inputType]="'email'"
            [errorIcon]="'assets/icon/icon_error.svg'"
            [infoIcon]="
              !preExistingContactInfo.email.editable
                ? '../../../../assets/icon/icon_info_gray.svg'
                : null
            "
            [disabled]="shouldDisabledEmailInput"
          ></zaver-animated-form-input>
        </div>

        <div class="input-container">
          <zaver-animated-form-input
            [size]="'large'"
            [placeholder]="'Handynummer'"
            [formControlName]="'phoneNumber'"
            [error]="form.controls.phoneNumber.invalid && showError"
            [errorMessage]="'Bitte geben Sie eine gültige Handynummer ein'"
            [inputMode]="'tel'"
            [autoComplete]="'tel'"
            [inputType]="'tel'"
            [showContent]="true"
            [errorIcon]="'assets/icon/icon_error.svg'"
            [disabled]="shouldDisabledPhoneInput"
            ><zaver-select-country
              [disabled]="shouldDisabledPhoneInput"
              [isMobile]="isMobile"
              [buttonId]="'select-country-code'"
              [items]="AVAILABLECOUNTRYCODES"
              (itemSelected)="setCountry($event)"
              [selectedItem]="selectedCountry"
            ></zaver-select-country>
          </zaver-animated-form-input>
        </div>
      </form>

      <div
        *ngIf="shouldDisabledEmailInput || shouldDisabledPhoneInput"
        class="input-message-wrapper"
      >
        <div class="input-disabled-message">
          Details beim Händler aktualisieren
        </div>
        <zaver-button-link
          text="Ändern"
          (click)="activateModal()"
          [iconUrl]="'assets/icon/Icon-Edit-Pen.svg'"
        ></zaver-button-link>
      </div>

      <app-general-error
        *ngIf="form.valid && noResponseError"
        class="general-error"
      ></app-general-error>

      <div class="footer-wrapper">
        <div class="footer-container">
          <div class="total-amount" *ngIf="state.totalCheckoutValue">
            <p>Gesamtbetrag:</p>
            <p>{{ state.totalCheckoutValue | value }}</p>
          </div>

          <div class="button-container">
            <zaver-primary-button
              [buttonType]="'submit'"
              [formId]="'email-and-phone-form'"
              [text]="'Weiter'"
              [disabled]="navigationInProgress"
              (click)="handleCtaClick()"
            ></zaver-primary-button>
          </div>

          <app-de-footer
            *ngIf="state.currentPageInformation.homePage"
            [showLink]="state?.zaverProduct !== 'TOKENIZED_ONBOARDING'"
            [selectorItems]="selectorItems"
            [tokenizedOnboardingText]="getTokenizedOnboardingText()"
            [tokenizedOnboardingUrl]="getTokenizedOnboardingUrl()"
          ></app-de-footer>
        </div>
      </div>
    </div>
  </div>

  <div
    *ngIf="
      !loading && currentView === View.CONFIRM_EMAIL && !internalServerError
    "
    class="contents-wrapper"
  >
    <div class="contents-container">
      <h1 class="heading">E-Mail Adresse bestätigen</h1>

      <form
        [formGroup]="confirmEmailForm"
        id="confirm-email-form"
        class="confirm-email-form"
      >
        <div class="input-container">
          <zaver-animated-form-input
            [size]="'large'"
            [placeholder]="'E-Mail Adresse'"
            [formControlName]="'email'"
            [error]="confirmEmailForm.controls.email.invalid && showError"
            [errorMessage]="'Bitte geben Sie eine gültige E-Mail Adresse ein'"
            [inputMode]="'email'"
            [autoComplete]="'email'"
            [inputType]="'email'"
            [errorIcon]="'assets/icon/icon_error.svg'"
          ></zaver-animated-form-input>
        </div>
        <div class="input-container">
          <zaver-animated-form-input
            [size]="'large'"
            [placeholder]="'E-Mail Adresse'"
            [formControlName]="'confirmEmail'"
            [error]="confirmEmailForm.invalid && showError"
            [errorMessage]="'Bitte geben Sie eine gültige E-Mail Adresse ein'"
            [inputMode]="'email'"
            [autoComplete]="'email'"
            [inputType]="'email'"
            [errorIcon]="'assets/icon/icon_error.svg'"
          ></zaver-animated-form-input>
        </div>
      </form>

      <div>
        <app-general-error
          class="form-error"
          *ngIf="form.valid && noResponseError"
        ></app-general-error>
      </div>

      <div class="footer-wrapper">
        <div class="footer-container">
          <div class="total-amount" *ngIf="state.totalCheckoutValue">
            <p>Gesamtbetrag:</p>
            <p>{{ state.totalCheckoutValue | value }}</p>
          </div>

          <div class="button-container">
            <zaver-primary-button
              [buttonType]="'submit'"
              [formId]="'confirm-email-form'"
              [text]="'Weiter'"
              [disabled]="navigationInProgress"
              (click)="confirmEmail()"
            ></zaver-primary-button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    *ngIf="!loading && currentView === View.NOT_FOUND && !internalServerError"
    class="contents-wrapper"
  >
    <div class="contents-container">
      <div class="footer-wrapper">
        <div class="footer-container">
          <h3 class="heading">Prüfen Sie Ihre Daten</h3>

          <p class="info-text">
            Die E-Mail Adresse war zuvor mit einer anderen Handynummer
            verknüpft. Bitte ändern Sie Ihre Angaben oder setzen Sie Ihr
            Zaver-Konto zurück.
          </p>

          <div class="account-details-wrapper">
            <p class="email">{{ form.controls.email.value }}</p>
            <p class="phone">{{ form.controls.phoneNumber.value }}</p>
          </div>

          <div class="button-container">
            <zaver-primary-button
              [text]="'Ändern'"
              [disabled]="navigationInProgress"
              (click)="setCurrentView(View.DEFAULT)"
            ></zaver-primary-button>
          </div>

          <div class="secondary-button-container">
            <zaver-secondary-button-outlined
              [disabled]="navigationInProgress"
              (click)="navigateToAccountRestoration()"
              [text]="'Konto wiederherstellen'"
            ></zaver-secondary-button-outlined>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<zaver-details-modal
  *ngIf="modalActive"
  [shouldHideCloseButton]="true"
  [color]="'#E6E9EF'"
  [title]="'Daten ändern'"
  [titleColor]="'#1B2235'"
  (onClose)="deactivateModal()"
>
  <div class="small-modal-wrapper">
    <div class="modal-text">
      Sind Sie sicher, dass Sie zu Ihrem Warenkorb zurückgehen wollen um die
      eingegebenen Daten zu ändern?
    </div>
    <div class="modal-button-container">
      <button class="modal-button" (click)="deactivateModal()">
        Nein, abbrechen
      </button>

      <button
        class="modal-button"
        [disabled]="navigationInProgress"
        (click)="routeToCancelUrl()"
      >
        Ja, ändern
      </button>
    </div>
  </div>
</zaver-details-modal>
